module.exports = __webpack_public_path__ + "img/ContactBook.0a72b7b2.svg";